import Registry from '../registry'
import React from 'react'
import Select from '../components/fields/Select'

const select = {
  name: 'Select',
  group: 'Choice',
  choices: raw => {
    if (!raw) return {}
    if (typeof raw === 'string') raw = raw.split('\n')
    return raw.reduce((obj, line) => {
      if (!line) return
      const [val, name] = line.split(':')
      obj[val.trim()] = name ? name.trim() : val.trim()
      return obj
    }, {})
  },
  options: {
    choices: {
      label: 'Choices',
      help: 'One choice per line.',
      required: true,
      type: 'list',
      of: {type: 'string'}
    },
    multiple: {
      label: 'Allow multiple selections?',
      type: 'boolean'
    },
    creation: {
      label: 'Allow item creation?',
      type: 'boolean'
    },
    default_value: {
      label: 'Default choice',
      type: 'string'
    }
  },
  schema: part => ({
    type: 'string',
    allowedValues: select.choices(part.choices),
    component: ({ options, value, onChange }) =>
      <Select options={options} value={value} onChange={onChange} />
  })
}

Registry.register('select', select)

export default select



// WEBPACK FOOTER //
// ./app/parts/select.js